import { z } from 'zod';

export const requestGuestAccountBodySchema = z.object({
  code: z.string(),
  username: z
    .string()
    .min(3, 'Must be at least 3 characters')
    .max(50, 'Must be at most 50 characters')
    .regex(/^[a-zA-Z0-9._%+-]+$/, 'Username contains invalid characters'),
});

export type RequestGuestAccountInputDto = z.infer<typeof requestGuestAccountBodySchema>;
